import { ThemeUICSSObject } from '@apia/theme';

const tree: ThemeUICSSObject = {
  // display: 'flex',
};

export default tree;
